import CropsLinkContainer from './containers/CropsLinkContainer';

export default CropsLinkContainer;
